<script lang="ts">
  export let link
  export let title
  export let subtitle = null
</script>

<div class="link">
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.85 1C12.85 0.530558 12.4694 0.15 12 0.15L4.35 0.15C3.88056 0.15 3.5 0.530558 3.5 1C3.5 1.46944 3.88056 1.85 4.35 1.85L11.15 1.85V8.65C11.15 9.11944 11.5306 9.5 12 9.5C12.4694 9.5 12.85 9.11944 12.85 8.65V1ZM1.60104 12.601L12.601 1.60104L11.399 0.398959L0.398959 11.399L1.60104 12.601Z"
      fill="white"
    />
  </svg>
  <div class="text-wrapper">
    <a href={link} target="_blank">{title}</a>
    {#if subtitle}
      <p>{subtitle}</p>
    {/if}
  </div>
</div>

<style>
  a {
    display: inline-block;
    text-decoration: none;
    color: #f9f9f9;
    font-size: 18px;
    font-weight: 400;
    border-bottom: 4px solid #00fff0;
    margin-bottom: 0.25rem;
  }

  p {
    color: #7b7b7b;
    margin-top: 0;
  }

  .link {
    display: flex;
    margin: 1.5rem 0;
  }

  svg {
    padding: 0.4rem 0.75rem 0.4rem 0;
    min-width: 13px;
  }
</style>
